import {
  SET_TARGET_CONTENT_ITEM,
  CLEAR_TARGET_CONTENT_ITEM,
  ADD_CONTENT_ITEM,
  CLONE_CONTENT_ITEM,
  DELETE_CONTENT_ITEM,
  UPDATE_CONTENT_ITEMS_LIST,
  UPDATE_CONTENT_ITEM,
  UPDATE_GLOBAL_CONTENT_ITEM,
  CONTENT_ITEM_CLEAR,
} from './../_types'
import uidGenerator from '@utils/UIDGenerator'
import * as ContentItems from '@components/Widgets/_contentItems/all'

const getDefaultState = () => {
  return {
    targetContentItemID: '',
    defaultContentItems: ContentItems,
  }
}
export const state = getDefaultState()

export const getters = {
  getDefaultContentItemByTypeName: (state) => (type) => {
    // Unlink any reactivity
    const newContentItem = JSON.parse(
      JSON.stringify(state.defaultContentItems[type]))
    newContentItem.id = uidGenerator()
    return newContentItem
  },
  hasSettingsByTypeName: (state) => (type) => {
    return Object.keys(state.defaultContentItems[type].settings).length !== 0
  },
}

export const mutations = {
  [SET_TARGET_CONTENT_ITEM](state, { rootState, id }) {
    state.targetContentItemID = id
    rootState.editor.showContentMenu = true
  },
  [CLEAR_TARGET_CONTENT_ITEM](state, rootState) {
    state.targetContentItemID = ''
    rootState.editor.showContentMenu = false
    rootState.editor.showSettingsMenu = false
  },
  [ADD_CONTENT_ITEM](state, { rootState, newItem }) {
    this._vm.$set(
      rootState.campaign.widget.widgetItems[rootState.campaign.widget.targetWidgetID].steps[
        rootState.campaign.step.targetStepID
        ].contentItems,
      newItem.id,
      newItem,
    )
  },
  [CLONE_CONTENT_ITEM](
    state, { rootState, cloneContentItem, cloneContentItemIndex }) {
    const widgetContentItemsList =
      rootState.campaign.widget.widgetItems[rootState.campaign.widget.targetWidgetID].steps[
        rootState.campaign.step.targetStepID
        ].contentItemsList
    this._vm.$set(
      rootState.campaign.widget.widgetItems[rootState.campaign.widget.targetWidgetID].steps[
        rootState.campaign.step.targetStepID
        ].contentItems,
      cloneContentItem.id,
      cloneContentItem,
    )
    widgetContentItemsList.splice(cloneContentItemIndex, 0, cloneContentItem.id)
  },
  [DELETE_CONTENT_ITEM](
    state, { rootState, widgetID, stepID, contentItemID, contentItemIndex }) {
    rootState.campaign.widget.widgetItems[widgetID].steps[stepID].contentItemsList.splice(
      contentItemIndex,
      1,
    )
    this._vm.$delete(
      rootState.campaign.widget.widgetItems[widgetID].steps[stepID].contentItems,
      contentItemID,
    )
  },
  [UPDATE_CONTENT_ITEMS_LIST](state, { rootState, newList }) {
    rootState.campaign.widget.widgetItems[rootState.campaign.widget.targetWidgetID].steps[
      rootState.campaign.step.targetStepID
      ].contentItemsList = newList
  },
  [UPDATE_CONTENT_ITEM](state, { rootState, id, path, attribute, data }) {
    rootState.campaign.widget.widgetItems[rootState.campaign.widget.targetWidgetID].steps[
      rootState.campaign.step.targetStepID
      ].contentItems[id][path][attribute] = data
  },
  [UPDATE_GLOBAL_CONTENT_ITEM](
    state, { rootState, id, itemName, path, attribute, data }) {
    rootState.campaign.widget.widgetItems[rootState.campaign.widget.targetWidgetID].settings[itemName][
      path][attribute] = data
  },
  [CONTENT_ITEM_CLEAR](state) {
    Object.assign(state, getDefaultState())
  },
}

export const actions = {
  setTargetContentItem({ commit, rootState, state }, id) {
    if (id !== state.targetContentItemID) {
      commit(CLEAR_TARGET_CONTENT_ITEM, rootState)
      commit(SET_TARGET_CONTENT_ITEM, { rootState, id })
    }
  },
  clearTargetContentItem({ commit, rootState }) {
    commit(CLEAR_TARGET_CONTENT_ITEM, rootState)
  },
  addContentItem({ commit, rootState }, newItem) {
    commit(ADD_CONTENT_ITEM, { rootState, newItem })
    const id = newItem.id
    commit(SET_TARGET_CONTENT_ITEM, { rootState, id })
  },
  cloneContentItem({ commit, state, rootState }, contentItemID) {
    const widgetContentItems =
      rootState.campaign.widget.widgetItems[rootState.campaign.widget.targetWidgetID].steps[
        rootState.campaign.step.targetStepID
        ].contentItems
    const widgetContentItemsList =
      rootState.campaign.widget.widgetItems[rootState.campaign.widget.targetWidgetID].steps[
        rootState.campaign.step.targetStepID
        ].contentItemsList
    const cloneContentItem = JSON.parse(
      JSON.stringify(widgetContentItems[contentItemID]))
    const cloneContentItemIndex = widgetContentItemsList.indexOf(
      contentItemID) + 1
    const id = uidGenerator()

    cloneContentItem.id = id
    commit(CLONE_CONTENT_ITEM, {
      rootState,
      cloneContentItem,
      cloneContentItemIndex,
    })
    commit(SET_TARGET_CONTENT_ITEM, { rootState, id })
  },
  deleteContentItem(
    { commit, state, dispatch, rootState },
    { widgetID, stepID, contentItemID, contentItemIndex },
  ) {
    if (state.targetContentItemID === contentItemID) {
      dispatch('clearTargetContentItem')
    }
    commit(DELETE_CONTENT_ITEM, {
      rootState,
      widgetID,
      stepID,
      contentItemID,
      contentItemIndex,
    })
  },
  updateContentItemsList({ commit, rootState }, newList) {
    commit(UPDATE_CONTENT_ITEMS_LIST, { rootState, newList })
  },
  updateContentItem({ commit, rootState }, { id, path, attribute, data }) {
    commit(UPDATE_CONTENT_ITEM, { rootState, id, path, attribute, data })
  },
  updateGlobalContentItem(
    { commit, rootState }, { id, itemName, path, attribute, data }) {
    commit(UPDATE_GLOBAL_CONTENT_ITEM,
      { rootState, id, itemName, path, attribute, data })
  },
}
